const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/nango-playground/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/(app)/org/$org/nango-playground/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type ProxyAction = {
  label: string;
  endpoint: string;
  method: 'GET' | 'POST';
  data?: unknown;
};
type WebhookSetupDoc = {
  title: string;
  steps: string[];
  note?: string;
};
type Connection = {
  id: string;
  organizationId: string;
  providerId: string;
  displayName: string | null;
  status: string;
  subtitle: string | null;
};
type Workspace = {
  id: string;
  name: string;
  url?: string | null;
};